import { observable, action } from "mobx"
import List from "app/stores/list"
import config from 'app/config.js'
import request from 'app/vendor/request'

export default class Store {
  @observable keywords = ""
  @observable selectedData = []
  @observable selectedRowKeys = []
  @observable list

  @action clearSelected = () => {
    this.selectedData = []
    this.selectedRowKeys = []
  }

  @action exportPointDiagram = (selectedRowKeys) => {
    return request.post(`${config.backend}/science/azf/groups/reports/download/images`)
      .send(selectedRowKeys.slice())
      .type("application/json")
      .checkToken()
      .commonDispose()
  }
  @action deleteDatalink = (recordId) => {
    return request.post(`${config.backend}/azf/mut/delete/${recordId}`)
      .send(recordId)
      .checkToken()
      .commonDispose()
  }
  
  static fromJS() {
    const store = new Store()
    store.list = new List(store, "azf/mut/query")
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/research/azf/dataManage.js